import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";

// import Router from './Router'

import 'bootstrap/dist/css/bootstrap.min.css';

import './index.css';

import App from './Router.js';

window.onload = () => {
    const element = document.createElement("div");
    document.getElementsByTagName("body")[0].appendChild(element);
    const root = createRoot(element);
    root.render(<App />)
}

